exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".captcha-container{margin-bottom:2em}.captcha-container .captcha-required-message{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/SubComponents/GoogleCaptcha.scss
// module id = 7687
// module chunks = 13